// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15lA8","content":"styles_content__2kfr2","tableWrap":"styles_tableWrap__1RdBa"};